import { useCallback, useEffect, useState } from 'react'
import './submit.scss'
import Block from '../../components/Base/Block';
import Productinfoinorder from '../../components/ProductInfoInOrder';
import View from '../../components/Base/View';
import Text from '../../components/Base/Text';
import Picker from '../../components/Base/Picker';
import Image from '../../components/Base/Image';
import { Button } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import util from '../../utils/util';
import orderManager from '../../manager/order';
import { toast } from '../../utils/toast';
import rm from '../../utils/rm';
import httpUtil from '../../utils/httpUtil';
import EventBus from '../../utils/EventBus';
import { uploadImageFile } from '../../utils/image';

const AfterSaleSubmit = () => {

    const [productItems, setProductItems] = useState<any[]>([]);
    const [rule, setRule] = useState<any>({});
    const [selectActionId, setSelectActionId] = useState<number>(-1);
    const [currentReasonIndex, setCurrentReasonIndex] = useState<number>(-1);
    const [imgs, setImgs] = useState<any[]>([]);
    const [isSubmiting, setSubmiting] = useState<boolean>(false);
    const [contentInput, setContentInput] = useState<string>("");

    const [errorTips, setErrorTips] = useState<string>("");

    useEffect(() => {
        document.title = "申请售后";
        const urlInfo = util.parasUrl(window.location.href);
        const parmas = urlInfo.params as any;
        if (parmas.itemid) {
            orderManager.getAfterSaleRule(parmas.itemid,
                (success: boolean, res: any, tips: string) => {
                    if (success) {
                        var result = res.data.Content
                        setRule(result);
                        setProductItems([result.Item])
                        setErrorTips("")
                    } else {
                        // util.toast(tips, 3000)
                        setErrorTips(tips)
                    }
                })
        }
    }, [])

    const onActionSelect = useCallback((id: number) => {
        setSelectActionId(id)
    }, [])

    const onActionSelectDisable = useCallback(() => {
        toast.warning("该商品不支持此操作")
    }, [])

    const bindReasonChange = useCallback((vaue: string, index: number) => {
        setCurrentReasonIndex(index);
        console.log("setCurrentReasonIndex", index)
    }, [])

    const feedbackSubmit = useCallback(() => {
        var that = this
        if (errorTips.length > 0) {
            toast.error(errorTips, 3)
            return
        }
        if (isSubmiting) {
            toast.warning('正在提交，请稍等')
            return
        }
        if (util.isUndefineOrEmpty(contentInput)) {
            toast.warning('请您详细描述您的售后请求~')
            return
        }
        if (
            rule.AvailableReturnActions.length > 0 &&
            selectActionId == -1
        ) {
            toast.warning('请选择申请操作~')
            return
        }
        if (
            rule.AvailableReturnReasons.length > 0 &&
            currentReasonIndex == -1
        ) {
            toast.warning('请选择申请原因~')
            return
        }
        var item = {
            OrderItemId: productItems[0].Id,
            Quantity: productItems[0].Quantity,
        }

        var PictureIds: number[] = []
        imgs.forEach(function (item, index, attr) {
            PictureIds.push(item.Id)
        })
        var model = {
            OrderId: rule.OrderId,
            Item: item,
            ReturnRequestActionId: selectActionId,
            ReturnRequestReasonId:
                rule.AvailableReturnReasons[currentReasonIndex].Id,
            Comments: contentInput,
            PictureIds: PictureIds,
        }
        setSubmiting(true)
        rm.showLoading({ title: "提交中..." })
        httpUtil.link(
            'placereturnrequest',
            'POST',
            model,
            true,
            function (success: boolean, res: any, tips: string) {
                rm.hideLoading()
                if (success) {
                    toast.success('提交成功')
                    EventBus.send(EventBus.names.SUBMIT_AFTERSALE_SUCCESS, {
                        orderId: model.OrderId,
                        orderItemId: item.OrderItemId,
                    })
                    setTimeout(function () {
                        rm.closeWindow()
                    }, 1000)
                } else {
                    toast.error(tips, 5)
                }
                setSubmiting(false)
            }
        )
    }, [errorTips, productItems, isSubmiting, contentInput, imgs, rule, selectActionId, currentReasonIndex])

    /**
      * 选择图片
      */
    const selectPicture = useCallback(() => {
        //TODO: 上传图片
        // 创建一个input元素
        var input = document.createElement('input');
        // 设置input类型为file，表示文件选择器
        input.type = 'file';
        input.accept = 'image/*'
        // 添加change事件监听器，当用户选择文件后触发
        input.addEventListener('change', function (event) {
            if(input.files && input.files.length > 0){
                uploadImageFile(input.files[0])
                .then(res=>{
                    console.log(res);
                })
            }
            // 获取选择的文件
            // var selectedFile = event.target?.files[0];
            // // 在这里你可以处理选择的文件，比如读取内容或上传到服务器等
            // console.log('选择的文件:', selectedFile);
        });
        // 触发文件选择器
        input.click();

    }, [])


    const deleteBlock = useCallback((index: number) => {
        var list = imgs.slice(0)
        list.splice(index, 1)
        setImgs(list)
    }, [imgs])

    return <View className='aftersale-submit-page'>
        {productItems?.map((productInfo, index) => {
            return (
                <Block>
                    <Productinfoinorder
                        productInfo={productInfo}
                        showBottomBorder={index != rule?.Items?.length - 1}
                    ></Productinfoinorder>
                </Block>
            )
        })}
        <View className={'main-content '}>
            {errorTips?.length == 0 ? (
                <Block>
                    <Text className="title">申请操作</Text>
                    <View className="error-type">
                        {rule?.AvailableReturnActions?.map((item: any) => {
                            return (
                                <View
                                    className={
                                        'error-type-item' +
                                        (selectActionId === item.Id
                                            ? ' error-type-item-active'
                                            : '') +
                                        ' ' +
                                        (!item.IsUsable ? 'error-type-item-disable' : '')
                                    }
                                    onClick={
                                        () => {
                                            if (item.IsUsable) {
                                                onActionSelect(item.Id)
                                            } else {
                                                onActionSelectDisable()
                                            }
                                        }
                                    }
                                    data-id={item.Id}
                                >
                                    {item.Name}
                                </View>
                            )
                        })}
                    </View>
                    <Picker
                        onChange={bindReasonChange}
                        value={currentReasonIndex}
                        range={rule?.AvailableReturnReasons?.map((i: any) => i.Name) || []}
                    // rangeKey="Name"
                    // hover
                    // hoverClass="view-item-hover"
                    >
                        <View className="flex-conainer setting-style-item reason-container">
                            <Text className="title flex-grow">申请原因</Text>
                            <Text className="setting-style-des">
                                {currentReasonIndex >= 0
                                    ? rule?.AvailableReturnReasons[currentReasonIndex].Name
                                    : '未选择'}
                            </Text>
                            <Image
                                className="setting-style-arrow"
                                src={require('../../images/right-arrow.png')}
                            ></Image>
                        </View>
                    </Picker>
                    <Text className="title">问题描述</Text>
                    <View>
                        <View className="input-container">
                            <TextArea
                                className="error-content"
                                value={contentInput}
                                onChange={(e) => {
                                    setContentInput(e.target.value)
                                }}
                                placeholder="请详细描述申请售后的具体原因"
                                name="errorContent"
                            ></TextArea>
                        </View>
                        <View className="img-list">
                            {imgs?.map((item, index) => {
                                return (
                                    <View className="img-list-item">
                                        <Image
                                            className="img-list-img"
                                            src={item.PictureUrl}
                                        ></Image>
                                        <Image
                                            className="post-image-delete"
                                            src={require('../../images/ib_delete.png')}
                                            data-index={index}
                                            onClick={() => {
                                                deleteBlock(index)
                                            }}
                                        ></Image>
                                    </View>
                                )
                            })}
                        </View>
                        {/* <View>
                            <Image
                                className="picture-select"
                                src={require('../../images/select-pic.png')}
                                onClick={selectPicture}
                            ></Image>
                        </View> */}
                        <View
                            className={
                                'feedback-submit-container padding-safe-area'
                            }
                        >
                            <Button
                                className="feedback-submit"
                                onClick={feedbackSubmit}>
                                提交
                            </Button>
                        </View>
                    </View>
                </Block>
            ) : (
                <Text className="title">{errorTips}</Text>
            )}
        </View>
    </View>
}

export default AfterSaleSubmit;